<template>
    <HeroSectionPage page_title="Contacts"/>
    <ContactsPage/>
    </template>
    <script>
    import ContactsPage from '@/components/ContactsPage.vue';
    import HeroSectionPage from '@/components/HeroSectionPage.vue';
    export default{
      components:{
        HeroSectionPage,
        ContactsPage

      }
    }
    </script>